import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Clock, SignOut } from '@phosphor-icons/react';

/**
 * Modal shown 30 seconds before auto-logout due to inactivity.
 * User can click "Nastavi sesiju" to stay logged in.
 */
export default function IdleWarningDialog({ open, secondsLeft, onStay, onLogoutNow }) {
  return (
    <Dialog open={open} onOpenChange={() => { /* prevent ESC/outside-click dismiss */ }}>
      <DialogContent
        className="max-w-md"
        data-testid="idle-warning-dialog"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <Clock size={24} weight="duotone" />
            Neaktivni ste
          </DialogTitle>
          <DialogDescription className="pt-2 text-sm">
            Iz bezbjednosnih razloga, bićete automatski odjavljeni za{' '}
            <strong className="text-red-600 text-lg" data-testid="idle-countdown">
              {secondsLeft}s
            </strong>
            {' '}zbog neaktivnosti.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 mb-2 h-2 bg-slate-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-amber-500 transition-all duration-1000"
            style={{ width: `${(secondsLeft / 30) * 100}%` }}
          />
        </div>

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 mt-4">
          <Button
            variant="outline"
            onClick={onLogoutNow}
            data-testid="idle-logout-now-btn"
            className="text-red-600 border-red-200 hover:bg-red-50"
          >
            <SignOut size={16} className="mr-2" /> Odjavi me sada
          </Button>
          <Button
            onClick={onStay}
            data-testid="idle-stay-btn"
            className="bg-blue-600 hover:bg-blue-700"
          >
            Nastavi sesiju
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
